import { render, staticRenderFns } from "./rodape.vue?vue&type=template&id=6f98511c&scoped=true"
import script from "./rodape.vue?vue&type=script&lang=js"
export * from "./rodape.vue?vue&type=script&lang=js"
import style0 from "./rodape.vue?vue&type=style&index=0&id=6f98511c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f98511c",
  null
  
)

export default component.exports